/**
 * The sidebar identity block's role line — the mockup's `.em`,
 * "Research Scientist · NOAA".
 *
 * Either half may be missing on a real member record, so the two are joined
 * only when both are there and the whole line collapses to null when neither
 * is: the sidebar omits the element rather than reserving an empty row, and a
 * member with only an organization still gets that organization rather than a
 * dangling separator.
 *
 * Trimmed on the way in because these fields come from a member-maintained
 * profile, where a whitespace-only value is indistinguishable from an empty one
 * to the person who typed it.
 */
export function ComposeRoleLine(jobTitle: string | null, organization: string | null): string | null {
    return [jobTitle, organization]
        .map((part) => part?.trim() ?? '')
        .filter((part) => part.length > 0)
        .join(' · ') || null;
}
